import React from 'react'
import UsersList from '../components/User/UsersList'
const UserManagement = () => {
  return (
    <>
      <UsersList />
    </>
  )
}

export  {UserManagement}